<template>
  <div class="result">
    <p>ваша реакция: {{ score }} мс</p>
    <div class="img">
      {{ img }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["score"],
  data() {
    return {
      img: null,
    };
  },
  mounted() {
     
    if (this.score < 260) {
      this.img = "скорост света";
    } else if (this.score < 360) {
      this.img = "скорост ниндзя";
    } else if (this.score < 480) {
      this.img = "скорост зайца";
    } else if (this.score < 540) {
      this.img = "скорост черепахи";
    } else {
      this.img = "скорост улитки";
    }
  },
};
</script>

<style>
.result {
  text-align: center;
  max-width: 400px;
  padding: 50px 10px;
  margin: 20px auto;
  background: rgb(225, 122, 245);
  border: 2px solid rgb(153, 19, 124);
  border-radius: 30px;
}
.img {
  max-width: 200px;
  margin: 20px auto;
}
.img img {
  width: 100%;
}
</style>